'use strict';

var React = require('react'),
    IconMixin = require('../../mixins/IconMixin');

var NotificationIcon = React.createClass({
  mixins: [IconMixin],

  renderSVG: function (size) {
    switch (size) {
    case 'small':
      return '<line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="9" y1="13" x2="9" y2="17"/><path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M2 13h14 0.01l-3.1-9.27C12.33 2.14 10.8 1 9 1S5.68 2.14 5.1 3.73L2 13"/>';
    case 'medium':
      return '<line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="16" y1="25" x2="16" y2="31"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="16" y1="1" x2="16" y2="3"/><path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M5 25h21.99H27L23.25 8C22.17 5.08 19.33 3 16 3S9.83 5.08 8.75 8L5 25"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="3" y1="25" x2="29" y2="25"/>';
    case 'large':
      return '<line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="23.99" y1="39.28" x2="23.99" y2="46.28"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="23.99" y1="2" x2="23.99" y2="4.81"/><path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M7.87 38.5h32.25 0.01l-5.5-25.66C33.05 8.56 28.88 5.5 24 5.5s-9.05 3.06-10.63 7.34L7.87 38.5"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="5" y1="38.5" x2="43" y2="38.5"/>';
    }
  }
});

module.exports = NotificationIcon;



/** WEBPACK FOOTER **
 ** ./atoms/icons/Notification.jsx
 **/